import React from 'react'
import { connect } from 'react-redux'
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'moment/locale/pt-br'
import '../../../css/components/react-datepicker.css';
import pt from 'date-fns/locale/pt';
import Titulo from '../../comum/Titulo';
import { alterouEmpresa } from '../../../actions/empresa/alterarEmpresaSelecionada';
import buscarFechamentosCaixa from '../../../actions/fechamento-caixa/usuario/buscarFechamentosCaixa';
import limparFechamentosCaixa from '../../../actions/fechamento-caixa/limparFechamentosCaixa';
import Autorizacao, { validaPerfis } from '../../../security/Autorizacao';
import {
  getFinanceiroAgencia,
  getFinanceiroCaixa,
  getGestorEmpresa,
  getOperadorEmpresa,
  getPerfisVendedores,
  PERFIL_ADMIN,
} from '../../../security/securityContext';
import CampoSelecionarEmpresa from '../../layout/CampoSelecionarEmpresa';
import FechamentoCaixa from './FechamentoCaixa';
import ModalFechamentoCaixa from './ModalFechamentoCaixa';
import CabecalhoRodapeTabela from '../../comum/CabecalhoRodapeTabela';
import PaginacaoFechamentoCaixa from '../PaginacaoFechamentoCaixa';
import BotoesPaginacaoFechamentoCaixa from '../BotoesPaginacaoFechamentoCaixa';
import { alterouFiltro, alterouPagina } from '../../../util/filtros';
import determinarPaginaAtual from '../../../actions/fechamento-caixa/determinarPaginaAtuaFechamentoCaixa';
import buscarFechamentoDia from '../../../actions/fechamento-caixa/usuario/buscarFechamentoDia';
import PainelFiltragem from './PainelFiltrosFechamentoCaixa';
import alterarRegistrosPorPagina from '../../../actions/fechamento-caixa/alterarRegistrosPorPaginaFechamentoCaixa';
import limparFiltroFechamentoCaixa from '../../../actions/fechamento-caixa/limparFiltroFechamentoCaixa';

registerLocale('pt', pt);
setDefaultLocale('pt');

export const CabecalhoTabela = () => (
  <div id="header-tabela" className="lista-table">
    <div className="row cabecalho-desktop">
      <div className="col-lg-2 col-xl-2 d-sm-none d-none d-md-block">Data</div>
      <div className="col-lg-3 col-xl-3 d-sm-none d-none d-md-block">Agente</div>
      <div className="col-lg-2 col-xl-2 d-sm-none d-none d-md-block">Quantidade de vendas</div>
      <div className="col-lg-2 col-xl-2 d-sm-none d-none d-md-block">Valor total de vendas</div>
      <div className="col-lg-2 col-xl-2 d-sm-none d-none d-md-block">Situacão</div>
    </div>
  </div>
);

export const CabecalhoTabelaRelatorio = () => (
  <thead>
  <tr>
    <th scope='col'>Data</th>
    <th scope='col'>Vendedor</th>
    <th scope="col">Tarifa</th>
    <th scope="col">Desconto</th>
    <th scope="col">SubTotal</th>
    <th scope="col">Taxa embarque</th>
    <th scope="col">Impostos</th>
    <th scope="col">Comissão</th>
    <th scope="col">Líquido</th>
    <th scope="col">Agência</th>
  </tr>
  </thead>
);


export class PainelFechamentoCaixa extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      dataSelecionada: null,
      itemFechamentoSelecionado: null
    };
  }

  selecionarItemFechamento (item) {
    this.setState({
      itemFechamentoSelecionado: item
    });
  }

  limparCampos() {
    this.props.limparFechamentosCaixa();
    // this.props.limparFiltroFechamentoCaixa();
  }

  componentDidMount () {
    this.limparCampos();
    if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
      this.buscarFechamentos();
      if (!validaPerfis([PERFIL_ADMIN])) {
        this.props.buscarFechamentoDia(this.props.empresaSelecionada.id)
      }
    }
  }

  componentDidUpdate (prevProps) {
    if (alterouEmpresa(this.props, prevProps) || alterouFiltro(this.props, prevProps) || alterouPagina(this.props, prevProps)) {
      this.buscarFechamentos();
      if (!alterouPagina(this.props, prevProps)) {
        this.props.determinarPaginaAtual(1)
      }
    }
  }

  exibirTabela () {
    if ((this.props.fechamentosCaixa && this.props.fechamentosCaixa.length) || this.props.fechamentoCaixaDia) {
      return (<div id='tabela-pedidos'>
          <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoFechamentoCaixa}
                                 BotoesPaginacao={BotoesPaginacaoFechamentoCaixa}
                                 pedidos={this.props.pedidos}
                                 empresaSelecionada={this.props.empresaSelecionada}>
            <CabecalhoTabela idEmpresa={this.props.empresaSelecionada.id}/>
            <div className="lista-table">
              {this.exibirFechamentoDia()}
              {this.exibirFechamento()}
            </div>
          </CabecalhoRodapeTabela>

        </div>
      )
    }
    return <div className="alert alert-warning text-center" role="alert">
      Não foi encontrado resultado para sua pesquisa.
    </div>;
  }

  exibirFechamento () {
    if (this.props.fechamentosCaixa && this.props.fechamentosCaixa.length) {
      return <div className="geral">{this.props.fechamentosCaixa.map(fechamento => <FechamentoCaixa key={fechamento.id} fechamento={fechamento}/>)}</div>
    }
  }


  buscarFechamentos () {
    this.props.buscarFechamentosCaixa(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados)
  }


  exibirCampoBuscaEmpresa () {
    return (<React.Fragment>
      <div className='row mb-4'>
        <div className="col-md-8">
          <CampoSelecionarEmpresa/>
        </div>
      </div>
    </React.Fragment>)
  }

  exibirFechamentoDia () {
    if (this.props.fechamentoCaixaDia) {
      return <div className="geral">
        <FechamentoCaixa fechamento={this.props.fechamentoCaixaDia} isFechamentoDia/>
      </div>
    }
  }

  exibirRelatorio () {
    if (this.props.fechamentosCaixa && this.props.fechamentosCaixa.length) {
      return <div>
        <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoFechamentoCaixa}
                               BotoesPaginacao={BotoesPaginacaoFechamentoCaixa}
                               empresaSelecionada={this.props.empresaSelecionada}>
          <div className='table-responsive '>
            <table className="table table-striped table-sm table-bordered text-center page-break" style={{ backgroundColor: '#FFF' }}>
              <CabecalhoTabelaRelatorio/>
              <tbody>
              {this.props.fechamentosCaixa.map(fechamentoCaixa =>
                <tr key={`relatorio-fechamento-${fechamentoCaixa.id}`}>
                  <td>
                    <span>{fechamentoCaixa.dataFechamento}</span>
                  </td>
                  <td>
                    <span>{fechamentoCaixa.nomeUsuario}</span>
                  </td>
                  <td>
                    <span>RS: 00.00</span>
                  </td>
                  <td>
                    <span>{fechamentoCaixa.totais.totalDesconto}</span>
                  </td>
                  <td>
                    <span>RS: 00.00</span>
                  </td>
                  <td>
                    <span>{fechamentoCaixa.totais.totalTaxaEmbarqueCEA}</span>
                  </td>
                  <td>
                    <span>{fechamentoCaixa.totais.totalImpostoRetido}</span>
                  </td>
                  <td>
                    <span>{fechamentoCaixa.totais.totalComissao}</span>
                  </td>
                  <td>
                    <span>RS: 00.00</span>
                  </td>
                  <td>
                    <span>RS: 00.00</span>
                  </td>
                </tr>)}
              </tbody>
            </table>
          </div>
        </CabecalhoRodapeTabela>
      </div>
    }
  }

  render () {
    return (
      <Autorizacao perfisPermitidos={[getOperadorEmpresa(this.props.empresaSelecionada.id),
        getFinanceiroAgencia(this.props.empresaSelecionada.id),
        getGestorEmpresa(this.props.empresaSelecionada.id),
        getFinanceiroCaixa(this.props.empresaSelecionada.id),
        ...getPerfisVendedores(this.props.empresaSelecionada.id), PERFIL_ADMIN]}
        empresaSelecionada={this.props.empresaSelecionada}>
        <div className="row internas">
          <Titulo texto="Fechamento de Caixa (Usuário)" urlRetorno="/menu-fechamento-caixa"/>
          <div className="col-12 filtro-busca">
            <PainelFiltragem/>
          </div>
          <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
              {this.exibirCampoBuscaEmpresa()}
            </Autorizacao>
            <div className="lista-table">
             {this.exibirTabela()}
            </div>
          </div>
        </div>
        <ModalFechamentoCaixa data={this.state.dataSelecionada} buscaFechamentos={this.buscarFechamentos.bind(this)}/>
      </Autorizacao>
    )
  }
}


export const mapStateToProps = state => (
  {
    fechamentosCaixa: state.fechamentosCaixa.fechamentos ? state.fechamentosCaixa.fechamentos : '',
    empresaSelecionada: state.empresaSelecionada ? state.empresaSelecionada : '',
    filtrosAdicionados: state.filtrosAdicionadosFechamentoCaixa ? state.filtrosAdicionadosFechamentoCaixa : '',
    paginaAtual: state.paginaAtualFechamentoCaixa ? state.paginaAtualFechamentoCaixa : '',
    registrosPorPagina: state.registrosPorPaginaFechamentoCaixa ? state.registrosPorPaginaFechamentoCaixa : '',
    fechamentoCaixaDia: state.fechamentoCaixaDia ? state.fechamentoCaixaDia : ''
  });


export default connect(mapStateToProps,
  {
    buscarFechamentosCaixa,
    limparFechamentosCaixa,
    limparFiltroFechamentoCaixa,
    buscarFechamentoDia,
    determinarPaginaAtual,
    alterarRegistrosPorPagina
  })(PainelFechamentoCaixa)
